var map = {
	"./logo-education-in-russia.png": "becf",
	"./logo-gosuslugi.png": "9ec9",
	"./logo-minobr.png": "fe63",
	"./logo-podacha-documentov.png": "1ab7",
	"./logo-portal-ege.png": "e1db",
	"./logo-postupai-pravilno.png": "463f",
	"./logo-recognition.png": "4116",
	"./logo-rosobrnadzor.png": "e70e",
	"./logominobrwhitecentre.png": "b0fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";